import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import Checkbox from 'meinian-package/src/baseComponent/checkbox'
import message from 'meinian-package/src/utils/message'

import store from './store'

export function getBatchSelected() {
  return store.selected || new Set()
}
export function setBatchSelected(value) {
  store.selected = value || new Set()
}
export function getBatchSelectedInfo() {
  // console.log('store.selectedInfo', store.selectedInfo)
  return store.selectedInfo || new Map()
}
export function answer(callback) {
  message.sub('messageBatchAll', () => callback && callback(getBatchSelected(), getBatchSelectedInfo()))
  message.sub('messageBatchItem', () => callback && callback(getBatchSelected(), getBatchSelectedInfo()))
  message.sub('messageBatchStop', () => callback && callback(getBatchSelected(), getBatchSelectedInfo()))
  message.sub('messageBatchStart', () => callback && callback(getBatchSelected(), getBatchSelectedInfo()))
}
export const Item = (props) => {
  const { className, style, hiddenCheckbox, keyValue, info } = props
  const [selected, setSelected] = useState(getBatchSelected())

  useEffect(() => {
    window.onbeforeunload = () => {
      setBatchSelected()
      store.selectedInfo = new Map()
    }
    answer(setSelected)
  }, [])

  const onChange = () => {
    if (selected.has(keyValue)) {
      selected.delete(keyValue)
      store.selectedInfo.delete(keyValue)
    } else {
      selected.add(keyValue)
      info && store.selectedInfo.set(keyValue, info)
    }
    setBatchSelected(new Set(selected))
    message.pub('messageBatchItem')
    props.onChange && props.onChange(keyValue)
  }
  return <span className={classNames(className, { active: selected.has(keyValue) })} style={style} onClick={() => onChange()}>
    {hiddenCheckbox ? props.children : <Checkbox
      checked={selected.has(keyValue)}
      className="checkbox"
      onChange={onChange}
      onClick={e => e.stopPropagation()}
    >
      {props.children}
    </Checkbox>}
  </span>
}

export const All = (props) => {
  const { className, style, placeholder = '全选', keyValues = [], infos } = props
  const [selected, setSelected] = useState(getBatchSelected())
  useEffect(() => {
    answer(setSelected)
  }, [])

  const onChange = (e) => {
    if (e.target.checked) {
      setBatchSelected(new Set([...selected, ...keyValues]))
      infos && keyValues.forEach((m, index) => store.selectedInfo.set(m, infos[index]))
    } else {
      setBatchSelected()
      store.selectedInfo = new Map()
    }
    message.pub('messageBatchAll')
    props.onChange && props.onChange(e)
  }
  return <span className={className} style={{ display: 'inline-flex', alignItems: 'center', ...style }} onClick={e => e && e.stopPropagation()}>
    <Checkbox
      checked={keyValues.length === selected.size}
      onChange={onChange}
    />
    <span style={{ marginLeft: '4px' }}>{placeholder}</span>
  </span>
}

export const AllButton = (props) => {
  const { keyValues = [], infos, className, selected, style } = props
  const onChange = (e) => {
    if (!keyValues.every(m => selected.has(m))) {
      setBatchSelected(new Set([...selected, ...keyValues]))
      infos && keyValues.forEach((m, index) => store.selectedInfo.set(m, infos[index]))
    } else {
      setBatchSelected()
      store.selectedInfo = new Map()
    }
    message.pub('messageBatchAll')
    props.onChange && props.onChange(e)
  }
  return <span className={className} onClick={onChange} style={style}>
    {props.children}
  </span>
}
export const Start = (props) => {
  const { className, style, } = props

  const onClick = (e) => {
    e && e.stopPropagation()
    setBatchSelected()
    store.selectedInfo = new Map()
    message.pub('messageBatchStart')
    props.onClick && props.onClick(e)
  }

  return <a className={className} style={style} onClick={onClick}>
    {props.children || '批量操作'}
  </a>
}

export const clearBatch = () => {
  setBatchSelected()
  store.selectedInfo = new Map()
  message.pub('messageBatchStop')
}

export const Stop = (props) => {
  const { className, style, children } = props

  const onClick = (e) => {
    e && e.stopPropagation()
    setBatchSelected()
    store.selectedInfo = new Map()
    message.pub('messageBatchStop')
    props.onClick && props.onClick(e)
  }

  return <span className={className} style={style} onClick={onClick}>
    {children || '取消'}
  </span>
}

export const Num = (props) => {
  const { className, style, prefix = '已选', suffix = '个' } = props
  const [selected, setSelected] = useState(getBatchSelected())

  useEffect(() => {
    answer(setSelected)
    return () => {
      setBatchSelected()
      store.selectedInfo = new Map()
    }
  }, [])

  return <span className={className} style={style}>
    {prefix}{selected.size}{suffix}
  </span>
}
